<div class="page-header-container">
    <div class="page-title">
        {{'adminUsers.title' | translate}}
    </div>
</div>

<div class="header-buttons-box">
    <div class="custom-text-input-container search-container flex-grow-1">
        <i class="app-icon icon icon-search icon-xl"></i>
        <div class="custom-text-input-wrap">
            <kendo-textbox
                type="text"
                [clearButton]='true'
                [placeholder]="'adminUsers.filterPopup.searchPlaceholder' | translate"
                (valueChange)="searchQuery$.next($event)">
            </kendo-textbox>
        </div>
    </div>

    <button *ngIf="activeFilterCount <= 0" class="btn white-btn text-uppercase" (click)="filterHandler()">
        {{'adminUsers.filter' | translate}}
    </button>
    
    <div class="buttons-group-box active-filters-reset" *ngIf="activeFilterCount > 0">
        <div class="btn-group" role="group">
            <button class="btn white-btn text-uppercase" (click)="filterHandler()">
                <span>{{'adminUsers.filterActive' | translate}}</span>
            </button>
            <button class="btn white-btn" (click)="resetFiltersHandler()">
                <span class="active-filters-badge">{{activeFilterCount}}</span>
                <i class="app-icon icon icon-close-circle-fill icon-lg"></i>
            </button>
        </div>
    </div>
    
    <div class="buttons-group-box table-view-mode-switch d-none d-lg-flex">
        <div class="btn-group" role="group">
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.LIST_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.LIST_VIEW">
                <i class="app-icon icon icon-view-list icon-lg me-2"></i>
                <span>{{ "common.listView" | translate }}</span>
            </button>
    
            <button class="btn white-btn" (click)="toggleViewMode(TABLE_VIEW_MODES.CARDS_VIEW)" 
                [disabled]="tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW">
                <i class="app-icon icon icon-view-grid icon-lg me-2"></i>
                <span>{{ "common.cardsView" | translate }}</span>
            </button>
        </div>
    </div>

    <button class="btn primary-btn" (click)="navigateAddEditFormHandler()">
        <i class="app-icon icon icon-add icon-xl me-2"></i>
        <span>{{'users.addUserBtn2' | translate}}</span>
    </button>
</div>

<div class="d-flex flex-column align-items-center my-5 my-lg-0" *ngIf="!hasFilterData">
    <no-records-placeholder
        [showNoRecordsHeader]="true"
        [isActiveFilter]="activeFilterCount > 0"
        (clickHereEvent)="resetFiltersHandler()"
    ></no-records-placeholder>
</div>

<admin-user-list-view
    *ngIf="(adminUsers?.length > 0 && tableViewMode === TABLE_VIEW_MODES.LIST_VIEW && windowSizeLgUp)"
    [users]="adminUsers"
    [props]="props"
    [deleteUser]="deleteUserHandler"
    [changeUserStatus]="userStatusHandler"
    [redirectUserDetails]="redirectUserDetails"
    [redirectUserRights]="redirectUserRights"
>
</admin-user-list-view>

<admin-user-card-view
    *ngIf="adminUsers?.length > 0 && tableViewMode === TABLE_VIEW_MODES.CARDS_VIEW || !windowSizeLgUp"
    [users]="adminUsers"
    [props]="props"
    [deleteUser]="deleteUserHandler"
    [changeUserStatus]="userStatusHandler"
    [redirectUserDetails]="redirectUserDetails"
    [redirectUserRights]="redirectUserRights"
    >
</admin-user-card-view>

